import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
    firstName: Yup.string()
        .max(30, 'Max 30 characters')
        .required('First Name is required'),
    lastName: Yup.string()
        .max(30, 'Max 30 characters')
        .required('Last Name is required'),
    phone: Yup.string()
        .test(
            'phoneIsValid',
            'Please enter a valid phone number',
            (value) => {
                if(!value) return true;
                const truncated = value.replace(/ /g, '').replace(/\(/g, '').replace(/\)/g, '').replace(/-/g, '');
                if(isNaN(truncated) || truncated % 1 !== 0 || truncated.toString().length !== 10) return false;
                else return true;
            }
        ),
    email: Yup.string()
        .email('Valid email required')
        .max(50, 'Max 50 characters')
        .required('Email is required'),
    userNotes: Yup.string()
        .max(5000, 'Max 5,000 characters'),
});

export function getInitCenterOption(center, centerOptions){
    if(!center) return { value: -1, label: 'None' };
    return centerOptions.find(c => parseInt(c.value) === parseInt(center)) || { value: -1, label: `Unknown center (ID ${center})` };
}

export const mpPermissionsOptions = ['Parent', 'Student', 'None'].map(i => ({ value: i, label: i }));
export const rpPermissionsOptions = ['Parent', 'Student', 'None'].map(i => ({ value: i, label: i }));
export function getInitPermissionsOption(permissions, permissionsOptions){
    if(!permissions) return { value: "None", label: 'None' };
    return permissionsOptions.find(p => p.value === permissions) || { value: -1, label: `Unknown group (${permissions})` };
}
